// document.body.innerHTML = document.body.innerHTML.replace(/sserving/g, "servings");

// document.addEventListener('DOMContentLoaded', function() {
//     // Select all elements with the class "xo-product-card__icon"
//     const buttons = document.querySelectorAll('.xo-product-card__icon');
    
//     // Add click event listeners to each button
//     buttons.forEach(function(button) {
//         button.addEventListener('click', function() {
//             // Refresh the page
//             window.location.reload();
//         });
//     });

//     // Check if the current page is /cart and reload it only once
//     if (window.location.pathname === '/cart') {
//         const hasReloaded = sessionStorage.getItem('cartPageReloaded');

//         if (!hasReloaded) {
//             setTimeout(function() {
//                 window.location.reload();
//                 sessionStorage.setItem('cartPageReloaded', 'true');
//             }, 300);
//         }
//     }
// });

//   document.addEventListener("DOMContentLoaded", function () {
//     function scrolldiv() {
//         var elem = document.getElementById("more_info");
//         if (elem) {
//             elem.scrollIntoView({ behavior: "smooth" });
//         } else {
//             console.error("Element with ID 'more_info' not found.");
//         }
//     }

//     // Attach the function to a button click
//     document.getElementById("custom_more").onclick = scrolldiv;
// });

 document.addEventListener("DOMContentLoaded", function () {
  // Focus the first quantity input field when the page loads
  const firstQuantityInput = document.querySelector("input[name='quantity']");
  // if (firstQuantityInput) {
  //   firstQuantityInput.focus();
  // }

  // Prevent Enter key from shifting focus
  document.querySelectorAll("input[name='quantity']").forEach(input => {
    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.keyCode === 13) {
        event.preventDefault(); // Stop default form submission
        event.target.blur(); // Remove focus temporarily
        setTimeout(() => event.target.focus(), 10); // Refocus after a short delay
      }
    });
  });
});


  // document.addEventListener("DOMContentLoaded", function () {
  //   const initializedSwipers = new Set();

  //   function initSwiperInPane(paneEl) {
  //     const swiperEl = paneEl.querySelector('.swiper.tab_products');
  //     if (!swiperEl || initializedSwipers.has(swiperEl)) return;

  //     new Swiper(swiperEl, {
  //       slidesPerView: 2,
  //       spaceBetween: 20,
  //       navigation: {
  //         nextEl: swiperEl.querySelector(".swiper-button-next"),
  //         prevEl: swiperEl.querySelector(".swiper-button-prev"),
  //       },
  //       breakpoints: {
  //         600: {
  //           slidesPerView: 2,
  //         },
  //         768: {
  //           slidesPerView: 3,
  //         },
  //         1024: {
  //           slidesPerView: 4,
  //         },
  //       },
  //       observer: true,
  //       observeParents: true,
  //     });

  //     initializedSwipers.add(swiperEl);
  //   }

  //   // Initialize the first visible tab pane
  //   const firstActivePane = document.querySelector("xo-tabs-pane[xo-active]");
  //   if (firstActivePane) {
  //     initSwiperInPane(firstActivePane);
  //   }

  //   // Observe changes to tabs using MutationObserver
  //   const tabObserver = new MutationObserver((mutationsList) => {
  //     mutationsList.forEach((mutation) => {
  //       if (
  //         mutation.type === "attributes" &&
  //         mutation.attributeName === "xo-active"
  //       ) {
  //         const newlyActive = mutation.target;
  //         if (newlyActive.hasAttribute("xo-active")) {
  //           initSwiperInPane(newlyActive);
  //         }
  //       }
  //     });
  //   });

  //   // Start observing all xo-tabs-pane elements
  //   document.querySelectorAll("xo-tabs-pane").forEach((pane) => {
  //     tabObserver.observe(pane, { attributes: true });
  //   });
  // });


// Postcode Field
document.addEventListener('DOMContentLoaded', function() {
  const btn = document.getElementById('find-store-btn');
  if (!btn) return;

  btn.addEventListener('click', async function() {
    const userPostcode = document.getElementById('postcode-input').value.trim();
    if (!userPostcode) {
      alert('Please enter a UK postcode.');
      return;
    }

    try {
      const res = await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(userPostcode)}`);
      if (!res.ok) throw new Error('Invalid postcode');
      const data = await res.json();
      const userLat = data.result.latitude;
      const userLng = data.result.longitude;

      let nearestStore = null;
      let shortestDistance = Infinity;

      window.ctoStores.forEach(store => {
        const distance = getDistance(userLat, userLng, store.lat, store.lng);
        if (distance < shortestDistance) {
          shortestDistance = distance;
          nearestStore = store;
        }
      });

      if (nearestStore && shortestDistance <= 64.37) {
        const miles = (shortestDistance / 1.60934).toFixed(1);
        document.getElementById('nearest-store-result').innerHTML = `
          <h4>Nearest Store (within 40 miles): ${nearestStore.name}</h4>
          <p>Distance: ${miles} miles</p>
          <p>Postcode: ${nearestStore.postcode}</p>
          <p>Phone: <a href="tel:${nearestStore.phone}">${nearestStore.phone}</a></p>
        `;
      } else {
        document.getElementById('nearest-store-result').innerHTML = `
          <p>Sorry, no store found within 40 miles of your postcode.</p>
        `;
      }

    } catch (error) {
      console.error(error);
      alert('Could not find location for that postcode. Please try again.');
    }
  });

  function getDistance(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
              Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  }

  function toRad(Value) {
    return Value * Math.PI / 180;
  }
});

